import { Component, Prop, Ref} from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class LoyaltyHeroPrimary extends ThemeComponent {
    @Prop() customer!: boolean;
    @Ref({ required: false }) data!: HTMLElement;
    @Ref({ required: false }) earnedPoints!: HTMLElement;
    @Ref({ required: false }) pendingPoints!: HTMLElement;

    init() {
        if(!this.customer) {
            return;
        }

        const target = document.querySelector('[data-lion-points]') as HTMLElement;
        const config = { childList: true, attributes: true };

        const observer = new MutationObserver(() => {
            this.process();
        });

        observer.observe(target, config);
    }

    process() {
        const lionElEarnedPoints = this.data.querySelector('[data-lion-points="approved"]') as HTMLElement;
        const lionElPendingPoints = this.data.querySelector('[data-lion-points="pending"]') as HTMLElement;

        if(!lionElEarnedPoints) {
            return;
        }

        if(!lionElPendingPoints) {
            return;
        }

        const earnedNumber = lionElEarnedPoints.textContent;
        const pendingNumber = lionElPendingPoints.textContent;

        this.earnedPoints.textContent = `You have ${earnedNumber} points.`;
        this.pendingPoints.textContent = `(${pendingNumber} pending)`;
    }
}
